module.exports = __webpack_public_path__ + "static/img/rectangle01.f649865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle01.jpg
// module id = XUEJ
// module chunks = 0